import React from 'react';
import cn from 'classnames';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { IconDownloadAnalysisSvg } from 'apps/sigma2-ui/src/components/svg/IconDownloadAnalysis';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface DownloadAnalysisButtonProps {
  onClick: () => void;

  /**
   * Whether the button is disabled
   */
  disabled: boolean;
}

export const DownloadAnalysisButton = ({
  onClick,
  disabled,
}: DownloadAnalysisButtonProps) => {
  const language = useLanguage();

  return (
    <div className={'inline-block max-w-full'}>
      <TouchTarget
        disabled={disabled}
        content={({ hovered }) => {
          return (
            <span
              className={cn(
                'flex rounded py-2 px-3 border-[1px] gap-2 items-center transition-all',
                {
                  'opacity-50 cursor-not-allowed': disabled,
                  'opacity-100 cursor-pointer': !disabled,
                  'bg-white border-gray-200': !hovered,
                  'bg-royal-100 border-royal-400': hovered,
                },
              )}
            >
              <IconDownloadAnalysisSvg
                svg={{
                  className: cn('w-[1em] h-[1em] transition-all', {
                    'text-royal-700': hovered,
                    'text-gray-900': !hovered,
                  }),
                }}
              />

              <S2Typography
                translatedContent={language.insightDownload()}
                variant={'headline-7-alt'}
                textColorVariant={hovered ? 'royal-700' : 'gray-900'}
              />
            </span>
          );
        }}
        behavior={{ type: 'onClick', onClick }}
      ></TouchTarget>
    </div>
  );
};
